import React, { FC } from 'react';

import styles from './CaseTab.module.scss';

interface Props {
  title: string;
  isSelected: boolean;
  caseId: number;
  onClick: (caseId: number) => void;
}

export const CaseTab: FC<Props> = (props) => {
  const { title, isSelected, onClick, caseId } = props;

  return (
    <div
      className={styles.tab}
      data-selected={isSelected}
      onClick={() => !isSelected && onClick(caseId)}
      data-test-id="case-tab-title"
    >
      <div className={styles.title}>{title}</div>
    </div>
  );
};
